import { Autofocus } from "./autofocus"

export const TabChange = {
  init() {
    window.addEventListener("phx:tab-change", TabChange.change)
  },

  change(event) {
    const tabs = document.getElementById(event.detail.tabs_id)
    const panel = tabs.querySelector(".tabs-panel:not([hidden])")

    if (panel) {
      Autofocus.autofocus(panel)
    }
  },
}
TabChange.init()
